import { storyblokEditable } from '@storyblok/react';
import Image from 'next/image';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import ExpandingButton from '@/components/elements/ExpandingButton';
import Heading from '@/components/elements/Heading';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';
import BlokLink from '@/components/elements/StoryblokLink/BlokLink';
import Text from '@/components/elements/Text';
import { sanitizeUrl } from '@/helpers/storyblokLink';

export interface PathProps {
  blok: any;
}

const Paths: FC<PathProps> = ({ blok }) => {
  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'wider'}>
        <StandardText blok={blok} size={StandardTextSize.MD} />
        <div
          className={`mt-16 grid-cols-[repeat(1fr,var(--grid-cols))] md:grid${blok.paths.length} bg-theme-black`}
          style={{
            // @ts-ignore
            '--grid-cols': blok.paths.length,
          }}
        >
          {blok.paths.map((s) => (
            <BlokLink
              key={s._uid}
              {...s}
              className="group relative block border-r-2 border-r-theme-charcoal transition-all duration-1000 ease-smooth hover:z-10 hover:flex-[2]"
            >
              <div className="h-full p-12 pb-28 pr-16">
                <div className="absolute inset-0 bg-theme-darkgrey duration-500 ease-smooth group-hover:scale-[1.025]">
                  <div className="absolute inset-0 shadow-xl duration-500 ease-smooth"></div>
                  <div className="absolute inset-0 overflow-hidden opacity-0 duration-500 ease-smooth group-hover:opacity-100">
                    <Image
                      alt={s.content?.background?.alt}
                      src={s.content?.background?.filename}
                      fill
                      sizes="(max-width: 768px) 100vw,
                  (max-width: 768px) 25vw,
                  25vw"
                      className={`absolute inset-0 object-cover duration-500 ease-smooth`}
                    />
                  </div>
                  <div className="absolute -inset-px bg-gradient-to-l from-theme-darkgrey/0 to-theme-darkgrey/90 opacity-0 duration-500 ease-smooth group-hover:opacity-80"></div>
                </div>

                <Heading
                  element="h3"
                  color="white"
                  size="xs"
                  className="relative z-10 mb-4 max-w-[12ch] font-semibold"
                >
                  {s.content.hero_heading}
                </Heading>
                <div className="relative z-10 space-y-8 self-end">
                  <Text size="md" color="white">
                    {s.content.hero_content}
                  </Text>
                </div>

                <ExpandingButton
                  link={sanitizeUrl(s.full_slug)}
                  className="absolute bottom-10 right-10 size-[52px] duration-1000 ease-smooth group-hover:w-52"
                >
                  Learn More
                </ExpandingButton>
              </div>
            </BlokLink>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Paths;
